export default {
  softSaleStockItems: [],
  softSaleStockItem: undefined,
};
